import WorkoutTemplatesPage from './WorkoutTemplatesPage';

export default WorkoutTemplatesPage;
